export default {
	'show-all-columns': 'Tüm sütunları göster',
	'total-arrested': 'Toplam tahsilat',
	'total-payments': 'Toplam Ödemeler',
	'the-difference': 'Fark'
}